import API from "./API";
import config from "./config"

const GeneralService = {
    //Get
    apiGetCallRequestWithWToken: function (url) {
        return new Promise((resolve, reject) => {
            API.get(`${url}`, {
                headers: {
                    "Content-Type": "application/json",
                    "wtoken": config.wToken
                },
            })
                .then((res) => resolve(res.data))
                .catch((error) => {
                    // reject(error);

                });
        });
    },
    //Get
    apiGetCallRequest: function (url, body="", token=null) {
        return new Promise((resolve, reject) => {
            API.get(`${url}`, {
                headers: {
                    "Content-Type": "application/json",
                    "wtoken": config.wToken,
                     token: token
                },
            })
                .then((res) => resolve(res.data))
                .catch((error) => {
                    reject(error);

                });
        });
    },
    //Post
    apiPostCallRequest: function (url, body = null, token=null) {
        return new Promise((resolve, reject) => {
            API.post(`${url}`, body, {
                headers: {
                    "Content-Type": "application/json",
                    "wtoken": config.wToken,
                    token: token
                },
            })
                .then((res) => resolve(res.data))
                .catch((error) => reject(error));
        });
    },

    //Post bolb for file/pdf
    apiPostBolbCallRequest: function (url, body = null) {
        return new Promise((resolve, reject) => {
            API.post(`${url}`, body, {
                headers: {
                    "Content-Type": "application/json",
                    "wtoken": config.wToken
                },
                responseType: 'arraybuffer'//'blob'
            })
                .then((res) => resolve(res.data,))
                .catch((error) => reject(error));
        });
    },
    //Delete
    apiDeleteCallRequest: function (url, params) {
        return new Promise((resolve, reject) => {
            API.delete(`${url}` + params, {
                headers: {
                    "Content-Type": "application/json",
                    "wtoken": config.wToken
                },
            })
                .then((res) => resolve(res.data))
                .catch((error) => reject(error));
        });
    },
    //Put
    apiPutCallRequest: function (url, params) {
        return new Promise((resolve, reject) => {
            API.put(`${url}`, params, {
                headers: {
                    "Content-Type": "application/json",
                    "wtoken": config.wToken
                },
            })
                .then((res) => resolve(res.data))
                .catch((error) => reject(error));
        });
    },
    //FormData
    apiPostCallFormDataRequest: function (url, body = null) {
        return new Promise((resolve, reject) => {
            API.post(`${url}`, body, {
                headers: {
                    "Content-Type": "application/form-data",
                    "wtoken": config.wToken
                },
            })
                .then((res) => resolve(res.data))
                .catch((error) => reject(error));
        });
    },
};
export default GeneralService;
